import { Link } from "@/i18n/navigation";
import { useLocale } from "next-intl";

export default function AirportLink({ airport }) {
  const locale = useLocale();

  if (!airport) {
    return null;
  }

  const { code, name, slug } = airport;

  // Dinamik URL oluştur - dil değişikliğine göre
  const getLocalizedPath = (locale) => {
    const paths = {
      tr: "/ucak-bileti",
      en: "/flight",
      de: "/flugticket",
      ar: "/تذكرة-الطيران",
    };
    return paths[locale] || paths.tr;
  };

  const href = `${getLocalizedPath(locale)}/${slug || code}`;

  return (
    <Link href={href} title={name} className="cursor-pointer">
      <div className="flex items-center">
        <span className="text-foreground text-base font-normal">{name}</span>
      </div>
    </Link>
  );
}
